// Mock data for Tharun Sai's Product Management Portfolio

export const heroData = {
  greeting: "Hello Everyone",
  name: "Tharun Sai",
  tagline: "Titles? Sure, I've had a few: entrepreneur, consultant\u2026 but my real job? Product Manager.",
  companies: [
    { name: "Bristol Myers Squibb", logo: "BMS" },
    { name: "ZS", logo: "ZS" },
    { name: "Opentalk", logo: "Opentalk" },
    { name: "Hope", logo: "Hope" },
    { name: "Okta", logo: "Okta" }
  ],
  imageUrl: "https://customer-assets.emergentagent.com/job_images-51/artifacts/bmezlpm5_1726222239098.jpeg"
};

export const products = [
  {
    id: 1,
    title: "Therapy Workflow Optimizer",
    tags: ["Workflow", "50% Cost Reduction", "TAM Growth", "Grew Revenue", "Won Awards", "User Empathy"],
    description: "Created a conversational form using Typeform for automating data, progress & therapy notes. Reduced therapy time & cost by 50%, increasing TAM through lower price points.",
    image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/cnjryj6u_workflow%20automation.png",
    accent: "#0F0F10",
    url: "https://docs.google.com/document/d/1Oj_YXVNH9FUIlYfMgQbv9cDQmRiA4YTSPqz8BFVejIg/edit?usp=sharing"
  },
  {
    id: 2,
    title: "Crisis Helpline",
    tags: ["Social Impact", "System Design", "API Integration", "30% Connection Lift", "Saved Lives", "Won Awards", "10x User Usage"],
    description: "Built a high-availability helpline routing system that connects callers in distress to the right counsellor faster. Smart queueing, fallbacks & API integrations lifted successful connections by 30%.",
    image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/dvxu8xbx_suicide%20helpline%20image.png",
    accent: "#0F0F10",
    url: "https://docs.google.com/document/d/1MeFrvUjBfYG78PJrza2jRMHHKSneiIs5cgLAcOw99yA/edit?usp=sharing"
  },
  {
    id: 3,
    title: "Data Privacy Remediation Platform",
    tags: ["B2B SaaS", "Data Privacy", "Adopted across 30 countries", "1st Product"],
    description: "Used OneTrust solutions to design assessments, gap identification, prioritisation & stakeholder reach out. Adopted company-wide across 30 offices, transitioned from excel-based operations.",
    image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/ofh4vu8i_privacy%20risk%20remediation.png",
    accent: "#FFF8E7",
    url: "https://docs.google.com/document/d/1unuh8kkMnYlx1R7QXa7LR9EPDpORL4cOittfWuxDz3M/edit?usp=sharing"
  },
  {
    id: 4,
    title: "Simulate",
    tags: ["Sim-based Learning", "Behavioural", "Dashboards", "Side Project"],
    description: "LeetCode for management \u2014 practise real-world scenarios from top firms across sales, ops & people leadership. Simulations test management, behavioural & emotional intelligence; a personal dashboard tracks progress, gaps & wins.",
    image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/h6sgcxot_Simulate.png",
    accent: "#FFF8E7",
    url: "https://docs.google.com/document/d/1zjgS-vDlMH_3r0Ns5aFxwG9rnjjGpJ4Poz-JviOxcJw/edit?usp=sharing"
  }
];

export const awards = [
  { id: 1, title: "G20 Summit", subtitle: "Honorary award by Gov. of India for building impactful products during the prestigious G20 Summit '23", image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/fmgo5ee2_image%20%282%29.png" },
  { id: 2, title: "Gov. of Telangana", subtitle: "Education Innovation Recognition", image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/zfkyjerm_image.png" },
  { id: 3, title: "Gov. of Hiroshima", subtitle: "Best Human Centric Design Innovator of the Year — R2S Program", image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/ogvrrk3t_Screenshot%202024-11-15%20084732.png" },
  { id: 4, title: "Balavikasa Kendra", subtitle: "Best Social Innovator of the Year '2023 — National Award from a globally acclaimed CSR & Social Innovator org.", image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/4gkqoqtf_image%20%281%29.png" }
];

export const newsArticles = [
  {
    id: 1,
    publication: "EdexLive",
    headline: "Peer counselling made easy with the help of this NIT Agartala student's web-based therapy portal",
    excerpt: "Web-based portal Find Hope gives you several reasons to feel on to that elusive feeling of hope, even when it feels like you are completely down and out.",
    url: "https://www.edexlive.com/breaking/peer-counselling-web-based-therapy-portal-find-hope-22096.html"
  },
  {
    id: 2,
    publication: "The New Indian Express",
    headline: "Mental health help at your fingertips",
    excerpt: "Khushi has been carefully designed by psychologists to address the specific needs of students.",
    url: "https://www.newindianexpress.com/cities/hyderabad/2023/Jun/18/mental-health-help-at-your-fingertips-2586085.html"
  },
  {
    id: 3,
    publication: "Precedence Research",
    headline: "Chatbots for Mental Health and Therapy Market to Hit USD 6,510 Million",
    excerpt: "In July 2023, the Osmania Technology Business Incubator (OTBI) and startup Findhope joined forces to organize the grand finale of the Ideathon featuring Khushi.",
    url: "https://www.globenewswire.com/news-release/2023/08/31/2735529/0/en/Chatbots-for-Mental-Health-and-Therapy-Market-to-Hit-USD-6-510-Million-by-2032.html"
  }
];

export const caseDecks = [
  {
    id: 1,
    title: "Scaling alternative stays in MakeMyTrip",
    subtitle: "MMT YoungTurks National comp.",
    award: "National Winner",
    stat: "3 out of ~3000 teams",
    star: "silver",
    college: "",
    color: "#FCE7B5",
    accentColor: "#B91C1C",
    badge: "makemytrip",
    url: "https://drive.google.com/file/d/1HWvaEJvwX5vd8XyowW_g31F6Sk96owiY/view"
  },
  {
    id: 2,
    title: "Building a super-app using ONDC for Bajaj Finserv",
    subtitle: "Series A Funding Round \u2013 Capital Crew",
    award: "National Winner",
    stat: "1 out of ~1200 teams",
    star: "diamond",
    college: "",
    color: "#1E3A8A",
    accentColor: "#FCD34D",
    badge: "Bajaj Finserv",
    url: "https://drive.google.com/file/d/1cJKGnD0NOvVhD3qqnL_5xfluIgOx7EVW/view?usp=sharing"
  },
  {
    id: 3,
    title: "Improving integration of ISVs in Okta Network",
    subtitle: "Case Comp Presentation",
    award: "Campus Winner",
    stat: "1 out of ~50 teams",
    star: "diamond",
    college: "Indian School of Business",
    color: "#1D4ED8",
    accentColor: "#FFFFFF",
    badge: "Okta",
    url: "https://drive.google.com/file/d/1u2QAV9NJALAKR2qqcWzVHnPvBG64-6F2/view"
  },
  {
    id: 4,
    title: "Building omnichannel experience for Health & Glow",
    subtitle: "IITBHU Flagship Product Comp",
    award: "National Winner",
    stat: "1 out of ~700 teams",
    star: "diamond",
    college: "",
    color: "#FEE2E2",
    accentColor: "#DC2626",
    badge: "Health & Glow",
    url: "https://drive.google.com/file/d/1HZFeDaryQNXG6gVDx7A5eqw3GkZY816L/view"
  },
  {
    id: 5,
    title: "Driving product-led Growth for Big Basket's Qcommerce",
    subtitle: "IIMB Flagship Product Case Comp",
    award: "National Winner",
    stat: "1 out of ~2000 teams",
    star: "diamond",
    college: "",
    color: "#DCFCE7",
    accentColor: "#16A34A",
    badge: "BBNow",
    url: "https://drive.google.com/file/d/1DrRM3J4vSRyhxoBIHt64WB-PwcuT3Psx/view"
  },
  {
    id: 6,
    title: "Building Hyper-personalisation for Push notifications at Blinkx",
    subtitle: "BrainAThon: Notifmaster Challenge",
    award: "National Winner",
    stat: "2 out of ~1500 teams",
    star: "gold",
    college: "",
    color: "#FCE7F3",
    accentColor: "#DB2777",
    badge: "blinkX",
    url: "https://drive.google.com/file/d/1zkdjKHl78kQ8t8d14olyNdenNjzSym2z/view"
  }
];

export const upcomingProducts = [
  {
    id: 1,
    title: "Launching Catalog V2",
    tags: ["UX revamping", "Search optimization", "SEO improvement"]
  },
  {
    id: 2,
    title: "Re-engagement for Telemetry",
    tags: ["ROI dashboard", "Telemetry", "Cross-team collaboration"]
  },
  {
    id: 3,
    title: "Enhancing Office 365 Integration",
    tags: ["Authentication", "Provisioning", "Import"]
  }
];

export const postMortems = [
  {
    id: 1,
    title: "Khushi \u2013 WhatsApp Chatbot",
    tag: "Sunset \u00b7 2023",
    reason: "Market invalidation",
    tags: ["6 Field Studies", "2K DAU", "Chatbot"],
    description: "A WhatsApp chatbot that helped students vent, explore emotions & do bite-sized exercises. Daily volume looked great, but 30-day retention collapsed once novelty wore off \u2014 students wanted real humans, and BSP messaging costs killed unit economics.",
    image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/ynu79x0p_Khushi%20Preview.png",
    url: "https://docs.google.com/document/d/1LCfMeN9jBDxtj-DpDxmahxiLHtXJ-eSxzmPyIwGANn8/edit?usp=sharing"
  },
  {
    id: 2,
    title: "Client Engagement App for Therapists",
    tag: "Sunset \u00b7 customers",
    reason: "Wrong willingness-to-pay",
    tags: ["Retention", "Calendar Integration", "Reminders"],
    description: "A platform for therapists to manage practice & lift client retention via reminders, assessments & calendar integrations. Therapists loved it but expected free; clients (the real payers) churned because therapists never pushed activation.",
    image: "https://customer-assets.emergentagent.com/job_images-51/artifacts/4bdwqofy_Client%20engagamenet%20app%20for%20therapists.png",
    url: "https://docs.google.com/document/d/1RJxVgUvSYrveWC9Q0dlSTYjv-uY4nnrGDGOCobt-3fE/edit?usp=sharing"
  }
];

export const postMortemMeta = {
  subtitle: "Didn't take off as expected despite a lot of iterations \u2014 I'll talk about why this happened."
};

export const originStory = {
  heading: "Building products from 5 years now!",
  quote: "It all started here \u2013 from a website with assessments & the option to connect with peer counsellors.",
  post: {
    author: "Tharun Erukulla",
    bio: "ISB Co\u201925, Impact Entrepreneur, Ex- ZS, NITA\u201921",
    timeAgo: "5 yr \u2022 Edited",
    hashtag: "#productupdate",
    body: [
      "Launched a peer counseling feature at findhope.",
      "We have recruited 12 peer counselors from DU, OU, Amity, CMR and JMU and catered 50+ hours of free counseling sessions to 109 students from 13 universities.",
      "\u201cLet's use the lockdown to improve our mental health and bring the best version of ourselves. If something is bothering you or your friends/family, you can use findhope's free peer counseling services.\u201d"
    ]
  }
};

export const artifact = {
  title: "Product Requirement Doc [PRD]",
  subtitle: "PM Assessments at HackerRank",
  description: "I am a PM at HackerRank, creating an assessment tool for existing clients to hire product managers.",
  metric: "5+ Recruiters found it interesting",
  url: "https://docs.google.com/document/d/1Eo-BkwpkNXSTa-bcg_Uc8wW55UtjyF0rluibgGwPopI/edit?usp=sharing"
};
